<template>
  <div class="switch-options">
    <div class="options">
      <div class="options-item" :class="{ active: active == 0 }" @click="handleSwitch(0, moreActive)">
        <img v-if="moreActive == 0" class="icon" src="@/assets/nikke_imgs/qs-icon.png" alt="" />
        <img v-else-if="moreActive == 1" class="icon" src="@/assets/nikke_imgs/zd-icon.png" alt="" />
        <img v-else-if="moreActive == 2" class="icon" src="@/assets/nikke_imgs/sj-icon.png" alt="" />

        <span class="label">Live 2d</span>

        <div class="switch-btn" title="切换" @click.stop="showMore = !showMore">
          <img src="@/assets/nikke_imgs/switch-icon.png" alt="" />
        </div>
        <div class="more" :style="{ width: showMore ? '222px' : '0px', opacity: showMore ? '1' : '0' }">
          <div
            class="more-item"
            :class="{ active: moreActive == 0 }"
            @click.stop="handleSwitch(0, 0)"
            v-show="showMore"
          >
            <img class="icon" src="@/assets/nikke_imgs/qs-icon.png" alt="" />
            <span class="label">全身</span>
          </div>
          <div
            class="more-item"
            :class="{ active: moreActive == 1 }"
            @click.stop="handleSwitch(0, 1)"
            v-show="showMore"
          >
            <img class="icon" src="@/assets/nikke_imgs/zd-icon.png" alt="" />
            <span class="label">战斗</span>
          </div>
          <div
            class="more-item"
            :class="{ active: moreActive == 2 }"
            @click.stop="handleSwitch(0, 2)"
            v-show="showMore"
          >
            <img class="icon" src="@/assets/nikke_imgs/sj-icon.png" alt="" />
            <span class="label">射击</span>
          </div>
        </div>
      </div>
      <div class="options-item" :class="{ active: active == 1 }" @click="handleSwitch(1)">
        <img class="icon" src="@/assets/nikke_imgs/lh-icon.png" alt="" />
        <span class="label">立绘</span>
      </div>
      <div class="options-item" :class="{ active: active == 2 }" @click="handleSwitch(2)">
        <img class="icon" src="@/assets/nikke_imgs/yy-icon.png" alt="" />
        <span class="label">语音</span>
      </div>
      <div class="options-item" :class="{ active: active == 3 }" @click="handleSwitch(3)">
        <img class="icon" src="@/assets/nikke_imgs/sd-icon.png" alt="" />
        <span class="label">SD 模型</span>
      </div>
      <div
        class="options-item"
        :class="{ active: active == 4 }"
        v-if="currentStyle.dzdh.hasValue && currentStyle.dzdh.value"
        @click="handleSwitch(4)"
      >
        <img class="icon" src="@/assets/nikke_imgs/dh-icon.png" alt="" />
        <span class="label">大招动画</span>
      </div>
    </div>
    <div class="styles">
      <div
        class="style-item"
        v-show="!showStyleList"
        style="margin-right: 0"
        @click="() => (showStyleList = !showStyleList)"
      >
        <img class="top-bg" src="@/assets/nikke_imgs/style-line.png" alt="" />
        <img class="cover" :src="currentStyle.cover.value" alt="" />
        <span class="name" :data-map-type="currentStyle.name.type" :data-map-key="currentStyle.name.key">
          {{ currentStyle.name.value }}
        </span>
      </div>
      <div class="scroll-wrapper" ref="scroll" v-show="showStyleList">
        <div class="scroll-content">
          <template v-for="key in Object.keys(dataSource)">
            <div
              class="style-item"
              :key="key"
              v-if="dataSource[key].cover.hasValue && dataSource[key].cover.value"
              @click="handleSwitchStyle(key)"
            >
              <div v-if="selectionKey !== key" class="mask"></div>
              <img class="top-bg" src="@/assets/nikke_imgs/style-line.png" alt="" />
              <img
                class="cover"
                :src="dataSource[key].cover.value"
                :data-map-type="dataSource[key].cover.type"
                :data-map-key="dataSource[key].cover.key"
                alt=""
              />
              <span class="name" :data-map-type="dataSource[key].name.type" :data-map-key="dataSource[key].name.key">
                {{ dataSource[key].name.value }}
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="switch-btn" :class="{ active: showStyleList }" @click="handleShowStyle">
        <img src="@/assets/nikke_imgs/switch-icon.png" alt="" />
        切换
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import ScrollBar from "@better-scroll/scroll-bar";

BScroll.use(ScrollBar);

export default {
  name: "SwitchOptions",
  props: {
    currentStyle: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      bs: null,
      showMore: false,
      active: 0,
      moreActive: 0,
      showStyleList: false
    };
  },
  computed: {
    selectionKey() {
      return this.currentStyle.key;
    }
  },
  methods: {
    initBS() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3,
        scrollbar: {
          fade: false,
          interactive: true,
          scrollbarTrackClickable: true
        }
      });
    },
    handleShowStyle() {
      this.showStyleList = !this.showStyleList;
      if (!this.showStyleList) {
        this.bs && this.bs.destroy();
      }
      this.$nextTick(() => {
        if (this.showStyleList) {
          this.initBS();
        }
      });
    },
    handleSwitch(index, subIndex) {
      if (this.active == 0 && index == 0) {
        this.showMore = !this.showMore;
      } else {
        this.showMore = false;
      }
      this.active = index;
      if (typeof subIndex !== "undefined") {
        this.moreActive = subIndex;
      }
      this.$emit("handleSwitch", typeof subIndex !== "undefined" ? index + "_" + subIndex : index + "");
    },
    handleSwitchStyle(key) {
      this.$emit("switchStyle", key);
      this.handleSwitch(0, 0);
      this.handleShowStyle();
    }
  }
};
</script>

<style lang="less" scoped>
.switch-options {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1000;
}
.options {
  .options-item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    margin-bottom: 20px;

    cursor: pointer;

    &::before {
      position: absolute;
      z-index: 1;
      content: "";
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      transform: rotate(45deg);
      border: 2px solid #c1cfdd;
      background: linear-gradient(180deg, #464949 0%, #313131 100%);
    }
    &.active {
      &::before {
        background: linear-gradient(135deg, #76c6fe 0%, #4b9cea 100%);
      }
    }

    .icon {
      position: relative;
      z-index: 1;
      width: 32px;
      height: 32px;
    }
    .label {
      display: block;
      width: 56px;
      height: 20px;
      position: absolute;
      z-index: 1;
      bottom: -15px;
      left: 0px;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: center;
    }
  }

  .switch-btn {
    position: absolute;
    right: 0;
    top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    &::before {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      z-index: 0;
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 2px 2px 2px 2px;
      background: linear-gradient(180deg, #464949 0%, #313131 100%);
      transform: rotate(45deg);
    }
    img {
      position: relative;
      z-index: 1;
      width: 8px;
      height: 8px;
    }
  }

  .more {
    position: absolute;
    bottom: 2px;
    z-index: 0;
    left: 28px;
    width: 0;
    height: 25px;
    background: #454747;
    border-radius: 0px 16px 16px 0px;
    border: 1px solid #ffffff;
    opacity: 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 12px;
    padding-bottom: 5px;
    padding-right: 14px;
    transition: all 0.3s ease-in-out;

    .more-item {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      top: -4px;

      cursor: pointer;

      &::before {
        position: absolute;
        z-index: 1;
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 6px;
        transform: rotate(45deg);
        border: 2px solid #c1cfdd;
        background: linear-gradient(180deg, #464949 0%, #313131 100%);
      }
      &.active {
        &::before {
          background: linear-gradient(135deg, #76c6fe 0%, #4b9cea 100%);
        }
      }

      .icon {
        position: relative;
        z-index: 1;
        width: 24px;
        height: 24px;
      }
      .label {
        display: block;
        width: 44px;
        height: 14px;
        position: absolute;
        z-index: 1;
        bottom: -8px;
        left: 0px;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
        line-height: 14px;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}
.styles {
  position: relative;
  min-width: 89px;
  height: 147px;
  background: rgba(244, 248, 255, 0.7);
  border-radius: 0px 4px 4px 4px;
  padding: 6px;
  transition: all 0.3s;
  user-select: none;
  .scroll-wrapper {
    white-space: nowrap;
    max-width: 312px;
    overflow: hidden;
    .scroll-content {
      display: inline-block;
    }
  }

  .switch-btn {
    position: absolute;
    bottom: -30px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 89px;
    height: 24px;

    background: #3eafff;
    border-radius: 0px 0px 0px 0px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 4px;
    }
    &.active {
      background: #a9acad;
    }
  }

  .style-item {
    display: inline-block;
    position: relative;
    width: 77px;
    height: 135px;
    box-shadow: 0px 0px 2px 0px rgba(62, 175, 255, 0.25);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #ffffff;
    padding-top: 5px;
    margin-right: 6px;
    cursor: pointer;
    background-color: #252527;
    &:last-child {
      margin-right: 0;
    }
    .mask {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }
    .top-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5px;
    }
    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .name {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 75px;
      height: 19px;
      background: rgba(37, 37, 39, 0.25);
      font-weight: bold;
      font-size: 10px;
      color: #ffffff;
      line-height: 19px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
